import { css } from '@emotion/react';
import { CSSObject } from '@emotion/react';

import { colors } from './colors';

export const fontFaces = css`
  @font-face {
    font-family: 'IntelOne Display';
    src: '../assets/fonts/intelone-display-regular.woff2';
  }

  @font-face {
    font-family: 'IntelOne Text';
    src: '../assets/fonts/intelone-text-regular.woff2';
  }

  @font-face {
    font-family: 'IntelOne Text Medium';
    src: '../assets/fonts/intelone-text-medium.woff2';
    font-weight: bold;
  }
`;

// Headings (h1, h2, modal and card titles) use percix.ai's heading navy instead of black.
const HEADING_COLOR = colors.navy;

export const fontsCss: CSSObject = {
  h1: {
    fontFamily: '"IntelOne Display", sans-serif',
    fontSize: '36px',
    fontWeight: 400,
    lineHeight: '46px',
    color: HEADING_COLOR,
  },
};

export const fonts: Record<string, CSSObject> = {
  smallLabel: {
    fontFamily: '"IntelOne Text", sans-serif',
    fontSize: '12px',
    fontWeight: 500,
    lineHeight: '15px',
  },

  largeLabel: {
    fontFamily: '"IntelOne Text", sans-serif',
    fontSize: '14px',
    fontWeight: 500,
    lineHeight: '18px',
  },

  text: {
    fontFamily: '"IntelOne Text", sans-serif',
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '18px',
  },

  largeText: {
    fontFamily: '"IntelOne Text", sans-serif',
    fontSize: '18px',
    fontWeight: 400,
    lineHeight: '18px',
  },

  navTab: {
    fontFamily: '"IntelOne Text", sans-serif',
    fontSize: '24px',
    fontWeight: 500,
    lineHeight: '30px',
  },

  mini: {
    fontFamily: '"IntelOne Text", sans-serif',
    fontSize: '12px',
    fontWeight: 400,
    lineHeight: '15px',
  },

  h1: {
    fontFamily: '"IntelOne Display", sans-serif',
    fontSize: '36px',
    fontWeight: 400,
    lineHeight: '47px',
    color: HEADING_COLOR,
  },

  h2: {
    fontFamily: '"IntelOne Display", sans-serif',
    fontSize: '18px',
    fontWeight: 500,
    lineHeight: '23px',
    color: HEADING_COLOR,
  },

  infoPiece: {
    fontFamily: '"IntelOne Display", sans-serif',
    fontSize: '18px',
    fontWeight: 400,
    lineHeight: '23px',
  },

  displayText: {
    fontFamily: '"IntelOne Display", sans-serif',
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '18px',
  },

  smallTab: {
    fontFamily: '"IntelOne Text", sans-serif',
    fontSize: '20px',
    fontWeight: 500,
    lineHeight: '26px',
  },

  modalHeader: {
    fontFamily: '"IntelOne Display", sans-serif',
    fontSize: '24px',
    fontWeight: 500,
    lineHeight: '31px',
    color: HEADING_COLOR,
  },

  largerH1: {
    fontFamily: '"IntelOne Display", sans-serif',
    fontSize: '64px',
    fontWeight: 500,
    lineHeight: '83px',
    color: HEADING_COLOR,
  },

  bannerText: {
    fontFamily: '"IntelOne Display", sans-serif',
    fontSize: '22px',
    fontWeight: 400,
    lineHeight: '28px',
  },
} as const;
